import { useStocks } from "./stocks.composable";
import { GeneralStockModel } from "../models/generalstock.model";
import GeneralUserModel from "../models/generaluser.model";
import MediaEntity from "../models/mediaEntity.model";
import { StockMarkets, StockTagModel } from "../models/stocks.model";
import httpService from "@/services/http.service";
import utilService from "@/services/util.service";
import { openModal } from "jenesius-vue-modal";
import linkifyHtml from "linkify-html";
import "linkify-plugin-hashtag";
import * as linkify from "linkifyjs";
import { ref } from "vue";
import MediaViewerComponent from "../components/media-viewer/MediaViewerComponent.vue";
import { TYPE } from "vue-toastification";
const mediaArr = ref<MediaEntity[]>([]);
const selectedMediaIndex = ref<number>(-1);
const isMobileScreen = ref<boolean>(screen.width < 768);

export const useUserInterface = () => {
  const specialKeys: number[] = [8, 16, 17, 18, 46, 37, 38, 39, 40];
  const metaArr: any[] = [];
  var timeout: any = null;

  const { stocks, getstocks } = useStocks();

  const getStockJSON = (keyword: string | null = null) => {
    if (keyword && keyword.length) {
      keyword = keyword.toLowerCase();
      return stocks.value.filter(
        (x: any) =>
          x.symbolstring.toLowerCase().includes(keyword) ||
          x.companyName.toLowerCase().includes(keyword)
      );
    }
    return stocks.value;
  };

  const resizeTextField = (event: any) => {
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
  };

  const checkTextLimit = (event: any, maxLength: number) => {
    let len = event.target.innerHTML.length;
    if (specialKeys.includes(event.keyCode)) {
      return true;
    }
    if (len >= maxLength) {
      event.preventDefault();
      return false;
    }
  };

  const getLatestSpecialCharacter = (inputValue: string) => {
    var specialCharactersIndex: any = [];
    for (var i = 0; i < inputValue.length; i++) {
      if (inputValue[i] == "@" || inputValue[i] == "$") {
        specialCharactersIndex.push(i);
      }
    }
    if (specialCharactersIndex.length) {
      var index = specialCharactersIndex[specialCharactersIndex.length - 1];
      var str: string = inputValue.substring(index + 1);
      if (!str.includes(" ")) {
        return inputValue[index];
      }
    }
  };

  const checkForLinks = async (
    ev: any,
    dataModel: any,
    findMeta: boolean = true
  ) => {
    if (ev.target.innerText.length) {
      var links = linkify.find(ev.target.innerText);
      var suggestionToFind: any = getLatestSpecialCharacter(
        ev.target.innerText
      );
      if (suggestionToFind) {
        checkForSuggestions(ev.target.innerText, suggestionToFind, dataModel);
      }
      if (links && links.length) {
        ev.target.innerHTML = linkifyHtml(ev.target.innerHTML, {
          className: "anchor_tag",
          formatHref: {
            hashtag: (href: string) => `#`,
          },
        });
        setLastCaretPosition(ev.target);
        for (let url of links) {
          if (url.type == "hashtag") {
            if (
              dataModel.hashtags.findIndex((x: any) => x == url.value) == -1
            ) {
              dataModel.hashtags.push(url.value);
            }
          } else if (
            findMeta &&
            url.type == "url" &&
            (!dataModel.media || !dataModel.media.length)
          ) {
            try {
              var meta: any = metaArr.find((x) => x.url == url.href);
              if (!meta) {
                var meta = await getMetaData(url.href);
                if (meta) {
                  metaArr.push({ url: url.href, meta: meta });
                  dataModel.metaData.push(meta);
                }
              } else {
                dataModel.metaData.push(meta.meta);
              }
            } catch (e) {
            }
          }
        }
      } else {
        dataModel.metaData = [];
        dataModel.hashtags = [];
      }
    } else {
      clearPostData(dataModel);
    }
  };

  const clearPostData = (dataModel: any, isWatchlist: boolean = false) => {
    dataModel.hashtags = [];
    dataModel.suggestions = {};
    dataModel.metaData = [];
    dataModel.userTags = [];
    dataModel.stockTags = [];
    if (isWatchlist) {
      dataModel.watchList = [];
    }
  };

  const checkForSuggestions = async (
    inputValue: string,
    symbol: string,
    dataModel: any
  ) => {
    var lastIndex = inputValue.lastIndexOf(symbol);
    if (lastIndex != -1) {
      var value = inputValue.substring(lastIndex + 1).toLowerCase();
      if (!value.includes(" ")) {
        dataModel.suggestions["symbol"] = symbol;
        if (symbol == "@") {
          var arr: GeneralUserModel[] = await utilService.getUserByKeyword(
            value
          );
          dataModel.suggestions.list = arr.filter(
            (x) =>
              dataModel.userTags.findIndex(
                (y: any) => y.userName == x.userName
              ) == -1
          );
        } else if (symbol == "$") {
          if (/^\$\d+$/.test(inputValue)) return
          var stockArr: GeneralStockModel[] =
            await utilService.getStockCryptoByKeyword(value);
          dataModel.suggestions.list = stockArr.filter(
            (x) =>
              dataModel.stockTags && dataModel.stockTags.findIndex(
                (y: any) => y.symbol.substring(1) == x.symbol
              ) == -1
          );
        }
      }
    }
  };

  const convertTagToAnchor = (
    symbol: string,
    value: string,
    elemId: string,
    market: string = "",
    stockId: string = "",
    displayName?: string
  ) => {
    var classTag = "anchor_tag";
    var elem: any = document.getElementsByClassName(elemId);
    if (elem && elem.length > 0) {
      elem = elem[elem.length - 1];
      var lastIndex = elem.innerHTML.lastIndexOf(symbol);
      var href = "";
      if (symbol == "@") {
        classTag += "--user";
        href = `/profile/user/${value}`;
      } else if (symbol == "$") {
        classTag += "--cash";
        // if (market == StockMarkets.crypto) {
        //   href = `/stock/${stockId || value}`;
        // } else {
        href = `/stock/${stockId || value}`;
        // }
      }
      elem.innerHTML =
        elem.innerHTML.substring(0, lastIndex) +
        `<a class="${classTag}" id="${symbol}${value}" href="${href}">${displayName || symbol + value}</a>&nbsp;`;
    }
  };

  const getMetaData = async (url: string) => {
    var metaRes: any = await httpService.getURlMetaData(url);
    if (metaRes.data && metaRes.data.isSuccess) {
      return metaRes.data.data;
    }
  };

  const stripInlineStyles = (html: string): string => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const allElements = tempDiv.querySelectorAll('*');
    allElements.forEach(element => {
      element.removeAttribute('style');
      element.removeAttribute('class');
      element.removeAttribute('id');
      element.removeAttribute('data-v-e876237c');
      element.removeAttribute('data_testing_id');
      element.removeAttribute('tabindex');
      element.removeAttribute('contenteditable');
      element.removeAttribute('data-placeholder');
      element.removeAttribute('itemprop');
      element.removeAttribute('itemscope');
      element.removeAttribute('itemtype');
      element.removeAttribute('srcset');
      element.removeAttribute('sizes');
      element.removeAttribute('onclick');
    });

    return tempDiv.innerHTML;
  };

  const onPaste = (e: any) => {
    if (e.target.isContentEditable) {
      e.preventDefault();
      const html = e.clipboardData.getData("text/html");
      if (html && html.includes("<img")) {
        let cleanHtml = stripInlineStyles(html);
        cleanHtml = cleanHtml.replace(/(<img\b[^>]*>)(\s*)/gi, "$1&nbsp;");
        document.execCommand("insertHTML", false, cleanHtml);
        return;
      }
      let text = e.clipboardData.getData("text/plain");
      text = text
        .replace(/  /g, " &nbsp;")
        .replace(/\r\n|\r|\n/g, "<br>");
      document.execCommand("insertHTML", false, text);
      return;
    }

    e.preventDefault();
    var text = e.clipboardData.getData("text/plain");
    document.execCommand("insertHTML", false, text);
  };

  const debounceOnInput = (func: any, ms: number = 1000) => {
    clearTimeout(timeout);
    timeout = setTimeout((e: any) => func(e), ms);
  };

  const debounce = <T extends (...args: any[]) => any>(
    func: T,
    wait: number
  ): ((...args: Parameters<T>) => void) => {
    return (...args: Parameters<T>) => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        func(...args);
      }, wait);
    };
  };

  const setLastCaretPosition = (el: HTMLElement) => {
    const selection = window.getSelection()!;
    const range = document.createRange();
    selection.removeAllRanges();
    range.selectNodeContents(el);
    range.collapse(false);
    selection.addRange(range);
    el.focus();
  };

  const addStockTag = (stock: any, dataModel: any, textFieldClass: string) => {
    dataModel.stockTags.push(new StockTagModel("$" + stock.symbol, stock.type, stock.stockId));
    convertTagToAnchor(
      dataModel.suggestions.symbol,
      stock.symbol,
      textFieldClass,
      stock.type,
      stock.stockId,
    );
    dataModel.suggestions = {};
  };

  const addUserTag = (
    user: GeneralUserModel,
    dataModel: any,
    textFieldClass: string
  ) => {
    dataModel.userTags.push(user);
    convertTagToAnchor(
      dataModel.suggestions.symbol,
      user.userName!,
      textFieldClass,
      "",
      "",
      user.fullName!
    );
    dataModel.suggestions = {};
  };

  const checkIfTagExist = (
    symbol: string,
    body: string,
    list: any[],
    field: string | undefined = undefined
  ) => {
    var indexesToSplice: number[] = [];
    for (var i = 0; i < list.length; i++) {
      var id = `id="${symbol == "$" ? "" : symbol}"`;
      if (field) {
        id = `${id.substring(0, id.length - 1)}${list[i][field]}"`;
      } else {
        id = `${id.substring(0, id.length - 1)}${list[i]}"`;
      }
      if (!body.includes(id)) {
        indexesToSplice.push(i);
      }
    }
    for (let index of indexesToSplice) {
      list.splice(index, 1);
    }
  };

  const getTextarea = (
    type: string,
    value: string | null = null,
    dataModel: any,
    textfieldClass: string,
    dataKey: string = "body"
  ) => {
    var elem: any = document.getElementsByClassName(textfieldClass);
    if (elem && elem.length > 0) {
      elem = elem[elem.length - 1];

      if (type == "clear") {
        elem.innerHTML = elem.innerText = "";
      }
      else if (type == "getValue") {
        if (elem.innerHTML.slice(elem.innerHTML.length - 15) == "<div><br></div>") {
          if (elem.innerHTML.length > 63000) {
            elem.innerHTML = elem.innerHTML.substring(0, 63000);
            utilService.showToast(
              `Your post exceeds the maximum character limit of 63,000 characters`,
              TYPE.WARNING
            );
            moveCaretToEnd(elem);
          }
          dataModel[dataKey] = elem.innerHTML.slice(0, elem.innerHTML.length - 15);
        } else {
          if (elem.innerHTML.length > 63000) {
            elem.innerHTML = elem.innerHTML.substring(0, 63000);
            utilService.showToast(
              `Your post exceeds the maximum character limit of 63,000 characters`,
              TYPE.WARNING
            );
            moveCaretToEnd(elem);
          }
          dataModel[dataKey] = elem.innerHTML;
        }
        dataModel.plainTextBody = elem.innerText;
      }
      else if (type == "append" && value) {
        if (elem.innerText != value) {
          elem.innerText += value;
        }
      }
    }
  };
  const moveCaretToEnd = (el: any) => {
    let range = document.createRange();
    let sel: any = window.getSelection();
    range.setStart(el.childNodes[0], el.innerHTML.length);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  };

  const getTextareaTwo = (
    type: string,
    value: string | null = null,
    dataModel: any,
    textfieldClass: string
  ) => {
    var elem: any = document.getElementsByClassName(textfieldClass);
    if (elem && elem.length > 0) {
      elem = elem[elem.length - 1];
      if (type == "clear") {
        elem.innerHTML = elem.innerText = "";
      } else if (type == "getValue") {
        if (
          elem.innerHTML.slice(elem.innerHTML.length - 15) == "<div><br></div>"
        ) {
          dataModel.quotedText = elem.innerHTML.slice(0, elem.innerHTML.length - 15);
        } else {
          dataModel.quotedText = elem.innerHTML;
        }
        dataModel.quotedText = elem.innerText;
      } else if (type == "append" && value) {
        if (elem.innerText != value) {
          elem.innerText += value;
        }
      }
    }
  };

  const onBackspaceKey = (ev: any, dataModel: any) => {
    if (!ev.target.innerText.trim().length) {
      clearPostData(dataModel);
    }
    if (
      ev.keyCode == 46 ||
      ev.keyCode == 8 ||
      ev.code.toLowerCase() == "backspace" ||
      ev.code.toLowerCase() == "delete"
    ) {
      checkIfTagExist("$", dataModel.body, dataModel.stockTags, "symbol");
      checkIfTagExist("@", dataModel.body, dataModel.userTags, "userName");
    }
  };

  const viewMedia = (file: any, attachmentUrl: string) => {
    openModal(MediaViewerComponent, {
      file, attachmentUrl,
    })
  }

  return {
    stocks,
    viewMedia,
    mediaArr,
    selectedMediaIndex,
    isMobileScreen,
    resizeTextField,
    checkTextLimit,
    getStockJSON,
    checkForLinks,
    onPaste,
    onBackspaceKey,
    convertTagToAnchor,
    debounceOnInput,
    debounce,
    checkIfTagExist,
    addStockTag,
    getTextarea,
    getTextareaTwo,
    addUserTag,
  };
};
